import React from 'react';
import { useParams, Link } from 'react-router-dom';

function Equipment() {
  const { dogId } = useParams();
  // For now, assume dogName is passed or fetched; we'll pass it from DogProfile later
  const dogName = 'Dog Name Placeholder'; // Temporary, to be replaced

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h1>View {dogName}'s Equipment and Companions</h1>
      <p>This page will show equipment and companions for the dog.</p>
      <Link to={`/dog/${dogId}`}>Back to Profile</Link>
    </div>
  );
}

export default Equipment;